import BlujayChainIndex from "@/components/blujay/chain/BlujayChainIndex.vue";
import BlujayChainDetail from "@/components/blujay/chain/BlujayChainDetail.vue";

let routesBlujayChainAccess= [
    {
        path: '',
        meta: {
          title: "List Blujay Chain",
        },
        name: "BlujayChainIndex",
        component: BlujayChainIndex
    }, 
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Blujay Chain",
        },
        name: "BlujayChainDetail",
        component: BlujayChainDetail
    },
     
    
]

export default routesBlujayChainAccess
  